import { Component, Input, OnInit } from '@angular/core';
import * as L from 'leaflet';
import { MatDialog } from '@angular/material/dialog';
import { FileManagementService } from 'src/app/services/property-matrixV2/services';
import { Router } from '@angular/router';
import { AdvertGeneratorDto } from 'src/app/services/property-matrixV2/models';

const NO_IMAGE_AVAILABLE = 'assets/images/placeholders/property-matrix-placeholder.png';

@Component({
  selector: 'app-property-for-sale-card',
  templateUrl: './property-for-sale-card.component.html',
  styleUrls: ['./property-for-sale-card.component.scss']
})
export class PropertyForSaleCardComponent implements OnInit {
  @Input() advert: AdvertGeneratorDto | undefined;
  @Input() marker: L.Marker | undefined;
  @Input() layout: 'popup' | 'grid' = 'popup';

  ImageFileUrl: string = "";
  isFavorite: boolean = false;

  legendItems = [
    { iconName: 'construction', iconPath: 'assets/maps/legend/construction.png', text: 'Unfinished structures' },
    { iconName: 'expand',       iconPath: 'assets/maps/legend/expansion.png',    text: 'Expansion opportunity' },
    { iconName: 'whitebox',     iconPath: 'assets/maps/legend/whitebox.png',     text: 'White box' },
    { iconName: 'asset',        iconPath: 'assets/maps/legend/asset.png',        text: 'Asset sale' },
    { iconName: 'sync_alt',     iconPath: 'assets/maps/legend/goingconcern.png', text: 'Going concern' },
    { iconName: 'check_circle', iconPath: 'assets/maps/legend/approved.png',     text: 'Approved rights' },
    { iconName: 'schedule',     iconPath: 'assets/maps/legend/pending.png',      text: 'Pending rights' },
    { iconName: 'lightbulb',    iconPath: 'assets/maps/legend/potential.png',    text: 'Potential rights' },
  ];

  icons: { iconName: string; iconPath: string; text: string }[] = [];

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private fileManagementService: FileManagementService
  ) { }

  ngOnInit(): void {
    if (this.advert?.propertyImageFileId) {
      this.getFileURLWithFileId(this.advert.propertyImageFileId, 'image');
    } else {
      this.ImageFileUrl = "assets/images/placeholders/property-matrix-placeholder.png";
      this.ImageFileUrl = NO_IMAGE_AVAILABLE;
    }
    this.setAdvertIcons();
  }

  onFavorite(): void {
    this.isFavorite = !this.isFavorite;
  }

  onClose(): void {
    if (this.marker) {
      this.marker.closePopup();
    }
  }

  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.src = NO_IMAGE_AVAILABLE;
  }

  openPropertyDetailsPopup(): void {
    if (this.advert) {
      this.router.navigate(
        ['/property-for-sale/property-detail'],
        { queryParams: { id: this.advert.propertyListingId, ai: this.advert.id } }
      );
    }
  }

  closePropertyDetailsPopup(): void {
    if (this.marker) {
      this.marker.closePopup();
    }
  }

  private getFileURLWithFileId(fileId: string, fileType: string): void {
    this.fileManagementService.apiV1FileManagementGetFileFileIdGet({ fileId: fileId })
      .subscribe({
        next: (result: any | void) => {
          this.ImageFileUrl = result?.split('?')[0] ?? NO_IMAGE_AVAILABLE;
        },
        error: () => {
          this.ImageFileUrl = NO_IMAGE_AVAILABLE;
        }
      });
  }

  public getPropertyPriceDisplay(price: number | string | undefined): string {
    if (price == null || price === '') return '';
    const num = typeof price === 'string' ? parseFloat(price.replace(/[^0-9.-]+/g, '')) : price;

    if (isNaN(num)) return '';

    if (num >= 1000000) {
      const millions = Math.round((num / 1000000) * 10) / 10;
      return `R${millions}m`;
    }
    return `R${num.toLocaleString('en-ZA')}`;
  }

  setAdvertIcons(): void {
    if (!this.advert?.advertGenerateStatusses) return;

    this.icons = this.advert.advertGenerateStatusses
      .filter(status => this.legendItems.some(l => l.text === status.description))
      .map(status => {
        const legend = this.legendItems.find(l => l.text === status.description)!;
        return { iconName: legend.iconName, iconPath: legend.iconPath, text: legend.text };
      });
  }
}
